import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "@/components/site/Reveal";

const BG =
  "https://images.unsplash.com/photo-1770152626339-f55625a4c141?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800";

export const Ethos = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section ref={ref} className="relative h-[80vh] md:h-screen w-full overflow-hidden flex items-center grain">
      <motion.img
        style={{ y, scale: 1.2 }}
        src={BG}
        alt=""
        className="absolute inset-0 h-full w-full object-cover brightness-[0.35]"
      />
      <div className="absolute inset-0 bg-ink/65" />
      <div className="relative mx-auto max-w-[1200px] px-6 md:px-10">
        <Reveal>
          <p className="text-xs font-semibold tracking-[0.3em] uppercase text-gold mb-8">Yaklaşım</p>
        </Reveal>
        <Reveal delay={1}>
          <p className="font-semibold tracking-tight text-3xl sm:text-5xl lg:text-7xl leading-[1.1] text-sand max-w-5xl">
            Şeffaflık bir tercih değil, yöntemdir. Her ihale, her hakediş ve her karar; kayıt altında,
            izlenebilir ve denetlenebilir.
          </p>
        </Reveal>
      </div>
    </section>
  );
};
